import { useState, useEffect } from 'react';

export default function useWindowSize(mobileBreakpoint = 768, tabletBreakpoint = 1024) {
    const getSize = () => {
        const width = typeof window !== 'undefined' ? window.innerWidth : 0;
        const height = typeof window !== 'undefined' ? window.innerHeight : 0;
        return {
            width,
            height,
            isMobile: width < mobileBreakpoint,
            isTablet: width >= mobileBreakpoint && width < tabletBreakpoint,
            isDesktop: width >= tabletBreakpoint,
        };
    };

    const [size, setSize] = useState(getSize);

    useEffect(() => {
        const handleResize = () => {
            const newSize = getSize();
            setSize((prev) => {
                // Only update if there's an actual change
                if (
                    prev.width !== newSize.width ||
                    prev.height !== newSize.height ||
                    prev.isMobile !== newSize.isMobile ||
                    prev.isTablet !== newSize.isTablet ||
                    prev.isDesktop !== newSize.isDesktop
                ) {
                    return newSize;
                }
                return prev;
            });
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [mobileBreakpoint, tabletBreakpoint]);

    return size;
}